<template>
  <div class="w3-bar w3-teal hideNavBar">
    <router-link class="w3-bar-item w3-button " to="/home">Home</router-link>
    <router-link class="w3-bar-item w3-button " to="/about">About</router-link>
    <router-link class="w3-bar-item w3-button " to="/patients">Patients</router-link>

    <router-link class="w3-bar-item w3-hover-blue w3-button w3-right" v-if="!userLoggedIn" to="/login">Login</router-link>

    <button class="w3-bar-item w3-hover-blue w3-button w3-right" v-if="userLoggedIn" @click="logout">Logout</button>
    <router-link class="w3-bar-item w3-right w3-button" v-if="userLoggedIn" to="/userPage" > <span class="w3-small">user</span> {{userName}} </router-link>
    <router-link class="w3-bar-item w3-right w3-button" v-if="isUserRoot" to="/statsPage" > <span class="w3-small">Stats</span></router-link>
    <router-link class="w3-bar-item w3-right w3-button" v-if="isUserRoot" to="/adminPage" > <span class="w3-small">Admin</span></router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "navBar",
  computed:{
    ...mapGetters({userName:"getUserName", userLoggedIn:"getUserLoggedIn", isUserRoot:"getIsprivilegedUser"}),
  },
  methods: {
    ...mapActions({signOut: 'LOGOUT'}),
    logout(){
      console.log('logout now')
      this.signOut()
      .then(()=>{
        this.$router.push('login')
      })
      .catch(()=>{

      })
    }
  }
};
</script>

<style lang="less" scoped>

</style>